import axios from "axios";
import { base_url } from "../../utils/baseUrl";
import { config } from "../../utils/axiosconfig";

const getTemples = async () => {
  const response = await axios.get(`${base_url}temple/admin/all`, config);
  return response.data;
};

const createTemple = async (temple) => {
  console.log("Creating temple with data:", temple);
  // Check if modelFile and chantingAudio are present
  console.log("Temple modelFile:", temple.modelFile);
  console.log("Temple chantingAudio:", temple.chantingAudio);
  
  // Prepare the data to send to backend
  // Extract only the public_id and url properties for file objects
  const templeData = {
    ...temple,
    modelFile: temple.modelFile && temple.modelFile.public_id && temple.modelFile.url ? {
      public_id: temple.modelFile.public_id,
      url: temple.modelFile.url
    } : null,
    chantingAudio: temple.chantingAudio && temple.chantingAudio.public_id && temple.chantingAudio.url ? {
      public_id: temple.chantingAudio.public_id,
      url: temple.chantingAudio.url
    } : null
  };
  
  console.log("Processed modelFile:", templeData.modelFile);
  console.log("Processed chantingAudio:", templeData.chantingAudio);
  console.log("Sending temple data to backend:", templeData);
  
  const response = await axios.post(`${base_url}temple`, templeData, config);
  console.log("Temple creation response:", response.data);
  return response.data;
};

const updateTemple = async (temple) => {
  // Prepare the data to send to backend for update
  const templeData = {
    ...temple,
    modelFile: temple.modelFile && temple.modelFile.public_id && temple.modelFile.url ? {
      public_id: temple.modelFile.public_id,
      url: temple.modelFile.url
    } : null,
    chantingAudio: temple.chantingAudio && temple.chantingAudio.public_id && temple.chantingAudio.url ? {
      public_id: temple.chantingAudio.public_id,
      url: temple.chantingAudio.url
    } : null
  };
  
  console.log("Processed modelFile for update:", templeData.modelFile);
  console.log("Processed chantingAudio for update:", templeData.chantingAudio);
  console.log("Sending temple update data to backend:", templeData);
  
  const response = await axios.put(
    `${base_url}temple/${temple.id}`,
    templeData,
    config
  );
  return response.data;
};

const getTemple = async (id) => {
  const response = await axios.get(`${base_url}temple/${id}`, config);
  return response.data;
};

const deleteTemple = async (id) => {
  const response = await axios.delete(`${base_url}temple/${id}`, config);
  return response.data;
};

const uploadModelAndAudio = async (files) => {
  const formData = new FormData();
  for (let i = 0; i < files.length; i++) {
    formData.append("files", files[i]);
  }
  const response = await axios.post(`${base_url}upload/models-audio`, formData, {
    ...config,
    headers: {
      ...config.headers,
      "Content-Type": "multipart/form-data",
    },
  });
  return response.data;
};

export const templeService = {
  getTemples,
  createTemple,
  updateTemple,
  getTemple,
  deleteTemple,
  uploadModelAndAudio,
};